import { render, staticRenderFns } from "./MobileTablePro.vue?vue&type=template&id=16ea0392&scoped=true&"
import script from "./MobileTablePro.vue?vue&type=script&lang=js&"
export * from "./MobileTablePro.vue?vue&type=script&lang=js&"
import style0 from "./MobileTablePro.vue?vue&type=style&index=0&id=16ea0392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ea0392",
  null
  
)

export default component.exports